import { render } from "./EditLessonView.vue?vue&type=template&id=21a0cc74&scoped=true"
import script from "./EditLessonView.vue?vue&type=script&lang=js"
export * from "./EditLessonView.vue?vue&type=script&lang=js"

import "./EditLessonView.vue?vue&type=style&index=0&id=21a0cc74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a0cc74"]])

export default __exports__